<template>
  <el-dialog title="设置会员等级" v-model="visible" width="600px">
    <el-form ref="ruleForm" :model="addRow" label-width="100px">
      <form-item-rule label="会员等级" prop="isVip">
        <el-select v-model="addRow.isVip">
          <el-option label="普通" :value="0"></el-option>
          <el-option v-for="i in 6" :label="`VIP${i}`" :value="i"></el-option>
        </el-select>
      </form-item-rule>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="visible = false">取 消</el-button>
       <el-button type="primary" @click="doSave()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>

import FormItemRule from "@/components/el/form-item-rule.vue";

export default {
  name: "set-vip-level",
  components: {FormItemRule},
  data() {
    return {
      visible:false,
      addRow:{ids:[],isVip:0},
    }
  },
  mixins: [tableBase],
  methods: {
    open(ids,isVip){
      this.addRow = {ids:ids,isVip:isVip};
      this.visible = true;
    },
    doSave(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/user/expand/updateVip",this.addRow,res=>{
            this.$emit('load');
            this.visible = false;
          })
        }
      });
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
